// extracted by mini-css-extract-plugin
module.exports = {"toggleSwitch":"toggle-switch_toggleSwitch__1wyp7","track":"toggle-switch_track__1CUeX","handle":"toggle-switch_handle__3sAFS","active":"toggle-switch_active__N1vv6"};